export const ROLES = {
    AUDITOR: "AUDITOR",
    QUALITY_MANAGER: "QUALITY_MANAGER"
};

export const ROLE_LEVELS = {
    [ROLES.AUDITOR]: 1,
    [ROLES.QUALITY_MANAGER]: 2
};